$(function () {
	var swiper = new Swiper(".js-images", {
		slidesPerView: 'auto',
		spaceBetween: 0,
		loop: true,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
	});
})
